module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "modal",
    staticClass: "modal fade background-darken",
    class: { in: _vm.isOpen,
      show: _vm.isShow
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return; }
        _vm.close()
      },
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.modalSize,
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.needHeader) ? _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v("\n                        Modal\n                    ")])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n                    Body\n                ")])], 2), _vm._v(" "), (_vm.needFooter) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-220d4c12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Vue2BootstrapModal.vue
// module id = 11
// module chunks = 0